import { render, staticRenderFns } from "./ResizeObserver.vue?vue&type=template&id=c29dc86c&scoped=true&"
import script from "./ResizeObserver.vue?vue&type=script&lang=js&"
export * from "./ResizeObserver.vue?vue&type=script&lang=js&"
import style0 from "./ResizeObserver.vue?vue&type=style&index=0&id=c29dc86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29dc86c",
  null
  
)

export default component.exports